/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Filter_MoreInputs */

const en_directory_launch_filter_more = /** @type {(inputs: Directory_Launch_Filter_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More`)
};

const zh_directory_launch_filter_more = /** @type {(inputs: Directory_Launch_Filter_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多`)
};

/**
* | output |
* | --- |
* | "More" |
*
* @param {Directory_Launch_Filter_MoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_filter_more = /** @type {((inputs?: Directory_Launch_Filter_MoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Filter_MoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_filter_more(inputs)
	return zh_directory_launch_filter_more(inputs)
});
export { directory_launch_filter_more as "directory.launch.filter_more" }